import { API_REQUEST, GET_LIVECHAT_STATUS, SET_LIVECHAT_STATUS } from "../../actionTypes/actionsTypes";

export const getChatStatus = () => ({
    type: API_REQUEST,
    payload: {
        url: `/livechat/status/`,
        next: GET_LIVECHAT_STATUS,
        method: 'GET',
        authorization: false
    }
});

export const setChatState = (chatSet: boolean) => ({
    type: SET_LIVECHAT_STATUS,
    value: chatSet,
    payload: {}
})